import React from 'react';
import { UploadTab } from '../wizard/UploadTab';

interface UploadImagesStepProps {
  ownerId?: string | null;
  /**
   * Active own-catalog LL-NXX (primary or add-on). Forwarded to UploadTab
   * so upload-initiate sends `?catalogAliId=` and the backend mints the new
   * item's catalog number under the active catalog instead of falling
   * through to the user's primary. Parent (EditObject) is responsible for
   * gating this to non-delegated contexts via resolveCatalogAliIdForRequest.
   */
  catalogAliId?: string | null;
  toggleVisibility?: (imageId: string) => Promise<void>;
  imageVisibilityError?: string | null;
}

/**
 * Renders UploadTab inside the new /edit-object shell using the flat-flow
 * layout that mirrors the design mock (no accordions). The legacy
 * UploadObject path leaves `flat` off so its accordion chrome stays put.
 */
export const UploadImagesStep: React.FC<UploadImagesStepProps> = ({
  ownerId,
  catalogAliId,
  toggleVisibility,
  imageVisibilityError,
}) => (
  <UploadTab
    ownerId={ownerId}
    catalogAliId={catalogAliId}
    toggleVisibility={toggleVisibility}
    imageVisibilityError={imageVisibilityError}
    flat
  />
);
